const ZigZag = () => {
    const components = document.querySelectorAll('[data-component="zigzag"]');
    const modal = document.querySelector('#modal-video'); // modal global
    const closeBtn = modal.querySelector('.btnCloseModal'); // botão de fechar

    components.forEach(component => {
        const buttonVideo = component.querySelector('.btnOpenModal');

        if (!buttonVideo) return;

        buttonVideo.addEventListener('click', () => {
            const tipo = buttonVideo.dataset.tipo;
            const videoData = buttonVideo.dataset.video; // pode ser URL ou ID
            const content = modal.querySelector('.content');

            // limpa conteúdo anterior
            content.innerHTML = '';

            let html = '';

            if (tipo === 'video') {
                html = `
                    <video autoplay controls muted playsinline loop class="block w-full h-full object-cover">
                        <source src="${videoData}" type="video/mp4">
                        Seu navegador não suporta o elemento de vídeo.
                    </video>
                `;
            }

            if (tipo === 'youtube') {
                html = `
                    <iframe 
                        class="aspect-video w-full relative z-0"
                        src="https://www.youtube.com/embed/${videoData}?controls=1&showinfo=0&rel=0&autoplay=1&playlist=${videoData}&mute=1"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                    ></iframe>
                `;
            }

            content.innerHTML = html;

            // abre o modal
            modal.classList.add('open');
        });
    });

    // evento global de fechar
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            const content = modal.querySelector('.content');
            modal.classList.remove('open');
            content.innerHTML = ''; // remove vídeo/iframe
        });
    }
};

export default ZigZag;

if(document.querySelectorAll('[data-component="zigzag"]').length) {
    ZigZag();
}